import { useCallback, useMemo, useState } from 'react';
import { ScheduleService } from 'services/ScheduleService';
import { ShiftProfile } from 'repository/schedule/@types/ShiftProfile';
import { GridInputRowSelectionModel, GridColDef } from '@mui/x-data-grid-pro';

const scheduleService = new ScheduleService();

export const useShiftProfilesData = () => {
    const [rows, setRows] = useState<ShiftProfile[]>([]);
    const [loading, setLoading] = useState(false);
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selectedShiftProfile, setSelectedShiftProfile] = useState<GridInputRowSelectionModel | undefined>([]);
    const [selected, setSelected] = useState<any>([]);

    const loadData = useCallback(async () => {
        setLoading(true);
        try {
            const data = await scheduleService.shift_profile.getAll();
            setRows(data);
        } catch (error) {
            console.error('Error loading shift profiles:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    const columns: GridColDef[] = useMemo(
        () => [
            // { field: 'shift_profile_id', headerName: 'ID', width: 90, headerAlign: 'center', align: 'center' },
            {
                field: 'shift_profile_name',
                headerName: 'Nombre',
                flex: 1,
            },
            {
                field: 'shift_profile_description',
                headerName: 'Descripción',
                flex: 2,
            },
        ],
        [],
    );

    const cleanSelected = useCallback(() => {
        setSelected([]);
        setSelectedShiftProfile([]);
    }, []);

    return {
        rows,
        loading,
        loadData,
        selectedShiftProfile,
        setSelectedShiftProfile,
        contextMenu,
        setContextMenu,
        selected,
        setSelected,
        columns,
        cleanSelected,
    };
};
